<template>
  <section id="cotizacion">
    <div class="cotitrack-fondo extranet-fondo">
      <div class="row align-items-center">
        <div class="col-12 col-sm-6"></div>
        <div class="col-12 col-sm-6">
          <div class="cotitrack-contenido extranet-contenidor">
            <div>
              <h1><strong>DALE SEGUIMIENTO A TU COMPRA</strong></h1>
            </div>
            <p>No pierdas de vista tu producto en ningún momento.</p>
            <br />
            <div class="cotitrack-texto">
              <template v-if="logged">
                <router-link
                  :to="'/seguimiento'"
                  href
                  class="btn-al btn-al-lg btn-al-celeste"
                >
                  <strong>Inicia tu seguimiento</strong>
                </router-link>
              </template>
              <template v-else>
                <a
                  data-toggle="modal"
                  data-target="#myModal2"
                  class="btn-al btn-al-lg btn-al-celeste"
                  href
                >
                  <strong>Inicia tu seguimiento</strong>
                </a>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import axios from "axios";
import { config_settings } from '../../config.js';

//HTTP ERROR STATUS
  const NOT_FOUND = 404;
  const BAD_REQUEST = 400;
  const UNAUTHORIZED = 401;
  const CONFLICT = 409;
  const INTERNAL_SERVER_ERROR = 500;

  axios.interceptors.response.use(function (response) { return response; }, 
  function (error) {
    
    if(error.message === 'Network Error'){
      toastr.error("No se puede conectar con el servidor. Verifique su conexión a internet",
                       "ERROR",
                       {"iconClass": 'customer-danger'});
    }
    else if(error.response.status === UNAUTHORIZED){
      if(error.response.data.message === "Access is denied"){
         toastr.error("Usted no tiene los provilegios para acceder a esta sección",
                       "ERROR",
                       {"iconClass": 'customer-danger'});
      }
      else {
        return Promise.reject(error);
      }
    }
    else {
      return Promise.reject(error);
    }
});

export default {
  name: "TwoModules",
  data() {
    return {
      logged: false
    };
  },
  methods: {
    callUserInformation () {
      axios({
        method: 'get',
        url: config_settings.RESOURCE_SERVER_URL + '/GET/profile',
        headers: {
          Authorization: "Bearer " + localStorage.getItem('access_token')
        }
     })
      .then(response => {
        this.user = response.data;
        this.logged = true
      })
      .catch(error => {
       
        if(error.response.status === UNAUTHORIZED){
           this.refreshToken().then(_ => {
           this.callUserInformation ();
           })
           .catch(_ => {
              this.logged = false
              
           });
         }
         this.logged = false
      })
    },

    refreshToken(){
          var refresh_token = localStorage.getItem('refresh_token');
          var refresh_credentials = new FormData();
          refresh_credentials.append('grant_type', 'refresh_token');
          refresh_credentials.append('refresh_token',  refresh_token);
          refresh_credentials.append('id_store',  config_settings.STORE);

          const refreshingCall = axios({
            method: 'post',
            url: config_settings.AUTH_SERVER_URL+'/oauth/token',
            data: refresh_credentials,
            withCredentials: true,
            auth: {
                username: 'USER_CLIENT_APP',
                password: 'password'
            }})
            .then(response => {
              localStorage.setItem('access_token', response.data.access_token);
              localStorage.setItem('refresh_token', response.data.refresh_token);
              return Promise.resolve(true);
            });
            return refreshingCall;
    },

  },
  //manadatory function called from cardTemplate  
  created() {
    this.callUserInformation();
  }
}
</script>

<style>
.best-products {
  margin-bottom: 10px;
}

#cotizacion {
  padding: 0px;
}
</style>